import { useState } from "react";
import { useTheme } from "../context/ThemeContext";

export default function StatusToggle({ id, currentStatus, onConfirm }) {
  const { mode } = useTheme();
  const [showConfirm, setShowConfirm] = useState(false);
  const [saving, setSaving]           = useState(false);

  const isActive  = currentStatus === "active";
  const nextStatus = isActive ? "inactive" : "active";

  const handleConfirm = async () => {
    setSaving(true);
    try {
      await onConfirm(id, nextStatus);
    } finally {
      setSaving(false);
      setShowConfirm(false);
    }
  };

  return (
    <>
      {/* Toggle switch */}
      <div
        onClick={() => setShowConfirm(true)}
        title={`Click to set ${nextStatus}`}
        style={{ width:36, height:20, borderRadius:10, background: isActive ? "#22c55e" : "var(--border)", position:"relative", cursor:"pointer", transition:"background 0.2s", flexShrink:0, display:"inline-block" }}
      >
        <div style={{ position:"absolute", top:3, left: isActive ? 18 : 3, width:14, height:14, borderRadius:"50%", background:"#fff", boxShadow:"0 1px 3px rgba(0,0,0,0.2)", transition:"left 0.2s" }} />
      </div>

      {/* Confirmation modal */}
      {showConfirm && (
        <div
          onClick={(e) => { if (e.target === e.currentTarget) setShowConfirm(false); }}
          style={{ position:"fixed", inset:0, background:"rgba(0,0,0,0.3)", display:"flex", alignItems:"center", justifyContent:"center", zIndex:300 }}
        >
          <div style={{ background:"var(--surface)", border:`1px solid var(--border)`, borderRadius:10, padding:"24px 26px", width:340, boxShadow:"0 4px 24px rgba(0,0,0,0.10)", fontFamily:"'DM Sans', system-ui, sans-serif" }}>

            {/* Icon */}
            <div style={{ width:36, height:36, borderRadius:"50%", background: nextStatus === "active" ? "var(--green-bg)" : "var(--amber-bg)", border:`1px solid ${nextStatus === "active" ? "var(--green-border)" : "var(--amber-border)"}`, display:"flex", alignItems:"center", justifyContent:"center", marginBottom:14, fontSize:16 }}>
              {nextStatus === "active" ? "✓" : "⏸"}
            </div>

            <div style={{ fontSize:14, fontWeight:700, color:"var(--ink)", marginBottom:6 }}>
              Set to {nextStatus}?
            </div>
            <div style={{ fontSize:12, color:"var(--text-sub)", marginBottom:20, lineHeight:1.55 }}>
              This will mark <span style={{ fontFamily:"'IBM Plex Mono', monospace", fontWeight:500, color:"var(--ink)" }}>{id}</span> as <strong>{nextStatus}</strong>.
              {nextStatus === "inactive" && " Devices linked to this will stop receiving updates."}
            </div>

            <div style={{ display:"flex", gap:8, justifyContent:"flex-end" }}>
              <button
                onClick={() => setShowConfirm(false)}
                style={{ background:"var(--surface)", border:`1px solid var(--border)`, borderRadius:6, padding:"7px 14px", fontSize:12, color:"var(--text)", cursor:"pointer", fontFamily:"inherit" }}
              >
                Cancel
              </button>
              <button
                onClick={handleConfirm}
                disabled={saving}
                style={{ background: mode === "dark" ? "#3b82f6" : "var(--ink)", border:"none", borderRadius:6, padding:"7px 18px", fontSize:12, fontWeight:600, color:"#fff", cursor: saving ? "not-allowed" : "pointer", opacity: saving ? 0.7 : 1, fontFamily:"inherit" }}
              >
                {saving ? "Saving…" : `Confirm`}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}